import { createAction } from 'redux-api-middleware';
import { getHeaders } from '@core/actions/xhrRequest';

export const FETCH_BALANCE_INIT = 'FETCH_BALANCE_INIT';
export const FETCH_BALANCE_SUCCESS = 'FETCH_BALANCE_SUCCESS';
export const FETCH_BALANCE_FAILURE = 'FETCH_BALANCE_FAILURE';

export const fetchBalance = () => createAction({
    types: [FETCH_BALANCE_INIT, FETCH_BALANCE_SUCCESS, FETCH_BALANCE_FAILURE],
    endpoint: '/api/balance/view',
    method: 'GET',
    headers: getHeaders(),
    credentials: 'include',
});
